import { ref, computed } from '@vue/composition-api';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
function useOptionsSearch(options) {
    var query = ref();
    function updateQuery(value) {
        query.value = value;
    }
    function clearQuery() {
        query.value = undefined;
    }
    var hasQuery = computed(function () { var _a; return !!((_a = query.value) === null || _a === void 0 ? void 0 : _a.trim()); });
    var displayedOptions = computed(function () {
        if (!hasQuery.value) {
            return options.value;
        }
        var searchTerm = normalizeString(query.value);
        return options.value.filter(function (option) { return normalizeString(option.name).includes(searchTerm); });
    });
    var hasNoResults = computed(function () { var _a; return hasQuery.value && ((_a = displayedOptions.value) !== null && _a !== void 0 ? _a : []).length === 0; });
    // Strips diacritics and lowercases the text, ensuring that search isn't specific to diacrtics and
    // special characters, and is case-insensitive. Specific to languages in Superbet markets.
    function normalizeString(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, '').toLowerCase();
    }
    return {
        query: query,
        hasQuery: hasQuery,
        hasNoResults: hasNoResults,
        displayedOptions: displayedOptions,
        updateQuery: updateQuery,
        clearQuery: clearQuery,
    };
}

export { useOptionsSearch };
